import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Dates = () => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("dates");
      setDates(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!dates) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <div id="dates" class="dates">
        <div class="container">
          <div class="sec-title3 text-center">
            <span>Dates</span>
            <h2>Important Dates</h2>
          </div>
          <div class="timeline-container mx-auto">
            <div class="timeline-item">
              <h2>Paper Submission Start Date</h2>
              <p>{dates.paper_submission[0].text}</p>
            </div>
            <div class="timeline-item">
              <h2>Paper Submission Last Date</h2>
              <p>{dates.paper_submission_end_date[0].text}</p>
            </div>
            <div class="timeline-item">
              <h2>Acceptance Notification</h2>
              <p>{dates.acceptance[0].text}</p>
            </div>
            <div class="timeline-item">
              <h2>Camera Ready Paper</h2>
              <p>{dates.camera_ready_paper[0].text}</p>
            </div>
            <div class="timeline-item">
              <h2>Author Registration</h2>
              <p>{dates.last_date_registration[0].text}</p>
            </div>
            <div class="timeline-item">
              <h2>Conference</h2>
              <p>{dates.conference_date[0].text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dates;
